import React from "react";
import { useColorMode } from "@chakra-ui/react";

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Return a element which supports the color mode.
 *
 * @param {React.ElementType} Component The component.
 * @returns {(props: any) => JSX.Element} The function for a component with color mode properties.
 */
export function withColorMode(
  Component: React.ElementType,
): (props: any) => JSX.Element 
{
  /* eslint-enable @typescript-eslint/no-explicit-any */
  /**
   * Get a component with color mode properties.
   *
   * @param {any} props The color mode properties.
   * @returns {any} The component which uses color mode properties.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function ComponentWithColorModeProp(props: any): JSX.Element 
  {
    const colorMode = useColorMode();

    return <Component {...props} colorMode={colorMode} />;
  }

  return ComponentWithColorModeProp;
}